export enum MultiplePartyInvolvementType {
  OnlyMe = 'only-me',
  AnotherExternal = 'another-external',
  Both = 'both',
}
